import {
  Directive,
  ElementRef,
  Injector,
  Input,
  OnInit
} from '@angular/core';
import {
  AbstractControl,
  NgControl,
  NG_VALIDATORS,
  Validator
} from '@angular/forms';

import { CompanyCountryValidationsModel } from '../../companies/models/company-country-validations';
import { SessionService }              from '../../sessions/session.service';

@Directive({
  selector : '[worPostcodeValidator]',
  providers: [
    {
      multi      : true,
      provide    : NG_VALIDATORS,
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      useExisting: PostcodeValidator
    }
  ]
})
export class PostcodeValidator implements OnInit, Validator {
  private _control           : NgControl = null;
  private _defaultValidation = '^\\d+$';
  private _validations       : CompanyCountryValidationsModel;

  mask : string;
  regex: RegExp;

  get validations (): CompanyCountryValidationsModel {
    return this._validations;
  }

  @Input() set validations ( _validations: CompanyCountryValidationsModel ) {
    this._validations = _validations;

    if (this._control) {
      setTimeout(() => this._control.control.updateValueAndValidity());
    }
  }

  @Input('worPostcodeValidator') value: string;

  constructor (
    private injector      : Injector,
    private element       : ElementRef<HTMLInputElement>,
    private sessionService: SessionService
  ) {}

  ngOnInit () : void {
    this._control = this.injector.get(NgControl);
  }

  format ( value : string ) : string {
    return this.mask
      ? value.replace(this.regex, this.mask).replace(/-$/, '')
      : value;
  }

  getAndSetValidations () {
    const countryValidations = this.sessionService.countryValidation();

    this.mask = this.validations
      ? this.validations.postcode.mask
      : countryValidations.postcode.mask;

    const regex = this.validations
      ? this.validations.postcode.validation
      : countryValidations.postcode.validation;

    this.regex = new RegExp(regex || this._defaultValidation);
  }

  validate ( control: AbstractControl ) : { [ key: string ] : any } {
    this.getAndSetValidations();

    if (!control.value) {
      return null;
    }

    if (control.value.match(this.regex)) {
      if (this.mask) {
        this.element.nativeElement.value = this.format(control.value);
      }

      return null;
    }

    return { postcode: true };
  }
}